
import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import Edit from './edit';
import save from './save';
import metadata from './block.json';
import icons from './icons.js';

registerBlockType(metadata.name, {
	icon: icons.quote,
	category: 'custom-c4l-category',
	attributes: {
		text: {
			type: 'string',
		},
		caption: {
			type: 'string',
		}
	},
	example: {
		attributes: {
			text: {
				type: "Type the quote here",
			},
			caption: {
				type: "AUTHOR NAME, Work Title",
			}
		}
	},
	edit: Edit,
	save
});
